import richText from './richText';
import cards from './cards';
import video from './video';
import audio from './audio';
import embed from './embed';
import files from './files';
import button from './button';
import challenge from './challenge';
import poll from './poll';
import assessment from './assessment';
import blank from './blank';
import statsTracker from './statsTracker';
import order from './order';
import checklist from './checklist';
import openEnded from './openEnded';
import videoUpload from './videoUpload';
import social from './social';
import missingWords from './missingWords';
import custom from './custom';
import scorm from './scorm';
import typeform from './typeform';
import jotform from './jotform';
import contactUpdate from './contactUpdate';
import contactUpdates from './contactUpdates';
import calendly from './calendly';
import cal from './cal';
import signwell from './signwell';
import everee from './everee';
import formSubmission from './formSubmission';

export default [
  {
    group: 'presentation',
    title: 'Presentation',
    materialIcon: 'slideshow',
    types: [richText, cards, video, audio, files, scorm],
  },

  {
    group: 'quizzing',
    title: 'Quizzing',
    materialIcon: 'quiz',
    types: [challenge, openEnded, blank, missingWords, order, assessment],
  },

  {
    group: 'pulsing',
    title: 'Pulsing',
    materialIcon: 'trending_up',
    types: [videoUpload, poll, statsTracker, checklist],
  },

  {
    group: 'scheduling',
    title: 'Scheduling',
    materialIcon: 'event',
    types: [cal, calendly],
  },

  {
    group: 'dataCollection',
    title: 'Data Collection',
    materialIcon: 'assignment',
    types: [
      contactUpdates,
      formSubmission,
      jotform,
      typeform,
      signwell,
      everee,
      contactUpdate,
    ],
  },

  {
    group: 'other',
    title: 'Other',
    materialIcon: 'extension',
    types: [button, embed, social, custom],
  },
];
